import React, { Component } from 'react';
import { Map } from 'immutable';
// Utilities
import { ENTITY_TYPE } from '../utilities/CONSTANTS';
// Components
import File from './File';
import HorizontalRule from './HorizontalRule';
import Embedly from './Embedly';
import Iframe from './Iframe';
import Image from './Image';
import AtomicSelect from './AtomicSelect';
import AtomicResizable from './AtomicResizable';
import Table from './Table';

class Atomic extends Component {
    render() {
        const {
            blockProps,
            contentState,
            block,
            ...rest
        } = this.props;

        const {
            editorState,
            setEditorState,
            isNestedEditor,
            tableMethods,
            nestedEditorProps,
        } = blockProps;

        const entityKey = block.getEntityAt(0);
        const entity = entityKey != null ? contentState.getEntity(entityKey) : Map({ data: { src: null } });
        const isTable = block.hasIn(['data', 'rows']);
        const rows = block.getIn(['data', 'rows'], []);
        const entityData = entity.get('data');
        const { src, isPlaceholder, alt } = entityData;

        const readOnly = nestedEditorProps != null && nestedEditorProps.config.readOnly === true;
        const type = entity.get('type', '').toUpperCase();

        let component;

        if (isTable) {
            component = (
                <Table
                    rows={rows}
                    setEditorState={setEditorState}
                    tableKey={block.getKey()}
                    editorState={editorState}
                    {...rest}
                    {...tableMethods}
                    {...nestedEditorProps}
                    readOnly={readOnly}
                />
            );
        } else if (type === ENTITY_TYPE.HR) {
            component = (<HorizontalRule />);
        } else if (type === ENTITY_TYPE.FILE) {
            component = (<File readOnly={readOnly} entity={entity} />);
        } else if (type === ENTITY_TYPE.AUDIO) {
            component = (<audio controls src={src} />);
        } else if (type === ENTITY_TYPE.VIDEO) {
            component = (<video controls src={src} />);
        } else if (type === ENTITY_TYPE.IMAGE) {
            component = (
                <Image
                    src={src}
                    readOnly={readOnly}
                    editorState={editorState}
                    alt={alt}
                    isPlaceholder={isPlaceholder}
                    block={block}
                    setEditorState={setEditorState}
                    entityData={entityData}
                />
            );
        } else if (type === ENTITY_TYPE.EMBEDLY) {
            component = <Embedly block={block} editorState={editorState} readOnly={readOnly} entity={entity} />;
        } else if (type === ENTITY_TYPE.IFRAME) {
            component = <Iframe readOnly={readOnly} src={src} />;
        } else {
            component = null;
        }

        if ([ENTITY_TYPE.HR, ENTITY_TYPE.FILE].includes(type) && !readOnly) {
            component = (
                <AtomicSelect
                    setEditorState={setEditorState}
                    readOnly={readOnly}
                    block={block}
                >
                    {component}
                </AtomicSelect>
            );
        } else if ([ENTITY_TYPE.IFRAME, ENTITY_TYPE.EMBEDLY, ENTITY_TYPE.IMAGE].includes(type) && isPlaceholder !== true && isNestedEditor !== true) {
            component = (
                <AtomicResizable
                    editorState={editorState}
                    setEditorState={setEditorState}
                    block={block}
                    readOnly={readOnly}
                >
                    {component}
                </AtomicResizable>
            );
        }

        return component;
    }
}

export default Atomic;
